// src/utils/logger-adapter.js
// Adaptateur de logger robuste qui ne plante jamais

/**
 * Adaptateur de logger robuste qui fournit des fallbacks
 * Ce fichier résout les erreurs "is not a function" liées au logging
 */

// Logger Proxy sécurisé qui intercepte toutes les méthodes
const SafeLogger = {
    // Méthode log de base
    log: function(type, message, data = {}) {
        try {
            console.log(`[${type.toUpperCase()}] ${message}`, data);
            return true;
        } catch (e) {
            console.log("[LOGGER ERROR] Could not log message");
            return false;
        }
    },
    
    // Logging d'erreur
    error: function(error, context = {}) {
        try {
            let errorMessage = "";
            
            if (error instanceof Error) {
                errorMessage = error.message;
                context.stack = error.stack;
                context.name = error.name;
            } else if (typeof error === 'string') {
                errorMessage = error;
            } else {
                errorMessage = JSON.stringify(error);
            }
            
            console.error(`[ERROR] ${errorMessage}`, context);
            return true;
        } catch (e) {
            console.error("[LOGGER ERROR] Failed to log error");
            return false;
        }
    },
    
    // Warning
    warn: function(message, data = {}) {
        try {
            console.warn(`[WARNING] ${message}`, data);
            return true;
        } catch (e) {
            console.log("[LOGGER ERROR] Failed to log warning");
            return false;
        }
    },
    
    // Info
    info: function(message, data = {}) {
        try {
            console.info(`[INFO] ${message}`, data);
            return true;
        } catch (e) {
            console.log("[LOGGER ERROR] Failed to log info");
            return false;
        }
    },
    
    // Logging de transaction
    transaction: function(tx, status, details = {}) {
        try {
            console.log(`[TRANSACTION ${status}]`, {
                hash: tx?.hash || 'unknown',
                status,
                ...details
            });
            return true;
        } catch (e) {
            console.log("[LOGGER ERROR] Failed to log transaction");
            return false;
        }
    },
    
    // Lorsqu'une autre méthode est appelée
    catchAll: function(methodName, ...args) {
        try {
            console.log(`[${methodName.toUpperCase()}]`, ...args);
            return true;
        } catch (e) {
            console.log(`[LOGGER ERROR] Failed to log ${methodName}`);
            return false;
        }
    }
};

// Exporter un proxy qui intercepte toutes les méthodes appelées
export default new Proxy(SafeLogger, {
    get: function(target, prop) {
        // Si la méthode existe, la retourner
        if (typeof target[prop] === 'function') {
            return target[prop];
        }
        
        // Sinon, rediriger vers catchAll
        return (...args) => target.catchAll(prop, ...args);
    }
});
